import React, {useCallback, useContext, useEffect, useState} from 'react';
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {useFormContext} from "react-hook-form";
import {IntervistaContext, TamponiContext} from "../IntervistaOld";
import {AnagraficaContext, AppContext} from "../../../../../App";
import {setOpenSnackbar} from "../../../../../services/AppServices";
import {generateIntervista, resetAddIntervista, setIntervista} from "../../../../../services/IntervistaServices";
import {
	AccordionActions,
	AccordionDetails,
	Backdrop,
	Button,
	CircularProgress,
	Tooltip,
	Typography
} from "@mui/material";
import Grid from "@mui/material/Grid";
import {bigNoteRegisterNotRequired} from "../../../../../utils/RegisterUtils";
import {listaParamIsolamento, rischiEsposizione} from "../../../../../utils/arrays/Generics";
import {useParams} from "react-router-dom";
import {getArrayOf, getIntervistaApiData, getListaOf} from "../../../../../services/utils/IntervistaApiData";
import {updateTampone} from "../../../../../services/TamponiServices";
import CustomMultiText from "../../../../widgets/inputs/CustomMultiText";
import {RischioGrid} from "../content/RischioGrid";

const RischioStep = ({setStep, tipoPaziente}) => {
	const classes = BaseStyle();
	const {errors, getValues, register, trigger, setValue} = useFormContext();
	const intervistaContext = useContext(IntervistaContext);
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	const tamponiContext = useContext(TamponiContext);
	const [submit, setSubmit] = useState(false);
	let {idSoggetto, idIncompleta} = useParams();
	
	const goForward = useCallback(async () => {
		let data = getValues();
		let result2 = true;
		let result3 = true;
		let result4 = true;
		let result1 = await trigger([
			("scaricataAppImmuni"),
			("viaggiato14gg"),
			("regioni14gg"),
			("possibileEspRischio"),
			("viviDaSolo"),
		]);
		if (data["viaggiato14gg"] === "true") {
			result2 = await trigger([
				("paesiEsteri"),
			]);
		}
		if (data["regioni14gg"] === "true") {
			result2 = await trigger([
				("regioniVisitate"),
			]);
		}
		if (data["viviDaSolo"] === "false") {
			result2 = await trigger([
				("correttoIsolamento"),
			]);
		}
		let result = result1 && result2 && result3 && result4
		if (data["possibileEspRischio"] === "true" && getListaOf(rischiEsposizione, getValues()).length === 0) {
			setOpenSnackbar("warning", "Inserisci almeno una possibile fonte di rischio tra quelle indicate!", appContext.dispatch);
		} else if (data["viviDaSolo"] === "false" && data["correttoIsolamento"] === "true" && getArrayOf(listaParamIsolamento, getValues()).length === 0) {
			setOpenSnackbar("warning", "Inserisci almeno un di isolamento!", appContext.dispatch);
		} else if (result) {
			resetAddIntervista(intervistaContext.dispatch);
			setSubmit(true);
			
			setIntervista(getValues(), intervistaContext.dispatch);
			generateIntervista(getIntervistaApiData(
				{
					...getValues(),
					soggetto: {
						idSoggetto: (tipoPaziente === "pazientezero." && idSoggetto !== "NULL") ? idSoggetto : anagraficaContext.state.anagrafica?.idSoggetto
					},
					tipoContatto: tipoPaziente.replace(".", ""),
				}), intervistaContext.dispatch, idIncompleta)
		}
	}, [intervistaContext.dispatch, tipoPaziente, getValues, idSoggetto, appContext.dispatch, trigger, anagraficaContext.state.anagrafica, idIncompleta])
	
	useEffect(() => {
		if (submit && !intervistaContext.state.loadingAddIntervista && intervistaContext.state.errorAddIntervista === "") {
			setOpenSnackbar("success", "Intervista creata correttamente\nOra aggiorno lo stato del tampone", appContext.dispatch)
			if (submit && !tamponiContext.state.loadingGetTampone && tamponiContext.state.errorGetTampone === "") {
				updateTampone({
					...tamponiContext.state.tampone,
					stato: "Gestito",
					active: false,
				}, tamponiContext.dispatch)
			} else if (submit && !tamponiContext.state.loadingGetTampone && tamponiContext.state.errorGetTampone !== "") {
				setSubmit(false);
				setOpenSnackbar("error", tamponiContext.state.errorGetTampone, appContext.dispatch);
			}
		} else if (submit && !intervistaContext.state.loadingAddIntervistaIncompleta && intervistaContext.state.errorAddIntervistaIncompleta === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Intervista creata correttamente", appContext.dispatch)
			setStep(6);
		} else if (submit && !intervistaContext.state.loadingAddIntervista && intervistaContext.state.errorAddIntervista !== "") {
			setSubmit(false);
			setOpenSnackbar("error", intervistaContext.state.errorAddIntervista, appContext.dispatch);
		}
	}, [intervistaContext.state.loadingAddIntervista, intervistaContext.state.errorAddIntervista, submit, appContext.dispatch,
		tamponiContext.state.tampone, tamponiContext.dispatch, tamponiContext.state.loadingGetTampone, tamponiContext.state.errorGetTampone,
		intervistaContext.state.loadingAddIntervistaIncompleta, intervistaContext.state.errorAddIntervistaIncompleta, setStep])
	
	useEffect(() => {
		if (submit && !tamponiContext.state.loadingUpdateTampone && tamponiContext.state.errorUpdateTampone === "") {
			setSubmit(false);
			setOpenSnackbar("success", "Tampone aggiornato correttamente", appContext.dispatch);
			setStep(prevState => ++prevState);
		} else if (submit && !tamponiContext.state.loadingUpdateTampone && tamponiContext.state.errorUpdateTampone !== "") {
			setSubmit(false);
			setOpenSnackbar("error", tamponiContext.state.loadingUpdateTampone, appContext.dispatch);
		}
	}, [submit, tamponiContext.state.loadingUpdateTampone, tamponiContext.state.errorUpdateTampone, appContext.dispatch, setStep])
	
	useEffect(() => {
		listaParamIsolamento.forEach(item => {
			register(item.replace(/[\W_]+/g, "_"))
		})
		register("dataInizioIsolamento")
	}, [register])
	
	return (
		<React.Fragment>
			<Backdrop open={submit} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			<AccordionDetails>
				<Grid container spacing={3}>
					
					<RischioGrid/>
					
					<Grid item xs={12}>
						<Typography variant={"body2"} color={"textSecondary"}>
							Nel caso non appaiano dei vaccini sul diario ma il paziente li dichiara indica nelle note le date ed il
							tipo
						</Typography>
					</Grid>
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register(bigNoteRegisterNotRequired)}
							name={"note5"}
							label={"Ha effettuato il vaccino?"}
							autoFocus={false}
							rows={2}
							error={errors["note5"]}
						/>
					</Grid>
					<Grid item xs={12}>
						<CustomMultiText
							inputRef={register(bigNoteRegisterNotRequired)}
							name={"note4"}
							label={"Note aggiuntive"}
							autoFocus={false}
							error={errors["note4"]}
						/>
					</Grid>
				</Grid>
			</AccordionDetails>
			<AccordionActions>
				<Tooltip title={"Torna al passo precedente"}>
					<Button size={"small"} variant={"text"}
					        style={{borderRadius: 24}}
					        className={classes.roundButton} onClick={() => setStep(4)}>
						<b>Torna indietro</b>
					</Button>
				</Tooltip>
				<Tooltip title={"Precompila i campi con risposte negative nel caso in cui non siano pertinenti"}>
					<Button size={"small"} color={"secondary"} variant={"contained"}
					        disableElevation
					        disabled={submit}
					        style={{borderRadius: 24}}
					        className={classes.roundButton}
					        onClick={() => {
						        setValue("scaricataAppImmuni", "false")
						        setValue("viaggiato14gg", "false")
						        setValue("regioni14gg", "false")
						        setValue("possibileEspRischio", "false")
						        setValue("viviDaSolo", "true")
					        }}>
						<b>Non pertinente</b>
					</Button>
				</Tooltip>
				<Tooltip title={"Prosegui con il passo successivo"}>
					<Button size={"small"} color={"primary"} variant={"contained"}
					        disableElevation
					        disabled={submit}
					        style={{borderRadius: 24}}
					        className={classes.roundButton}
					        onClick={goForward}>
						<b>Prosegui</b>
					</Button>
				</Tooltip>
			</AccordionActions>
		</React.Fragment>
	);
};

export default React.memo(RischioStep);
